module.exports = __webpack_public_path__ + "img/user.1d63a9a7.svg";